<script setup>
import { onMounted, ref } from 'vue';
import { useFelixBagAuxStore } from '../../../store';

import PerguntasFrequentes from './components/PerguntasFrequentes.vue'
import ReportarDuvida from './components/ReportarDuvida.vue';

const felixBagAuxStore = useFelixBagAuxStore();
const openSubmenu = ref('')

const audio = document.createElement("audio")

onMounted(() => {

  felixBagAuxStore.muteVideo();
  audio.pause();
  audio.src = "https://overmediacast-videos-sp.s3.sa-east-1.amazonaws.com/videobot/vivo/audios_parametrizados/Suporte.mp3"
  audio.play();
});

</script>

<template>
  <div id="menu-suporte">
    <v-row align-items="center" justify="space-evenly" class="header">
      <div style="display: flex; flex-direction: column; align-items: start; padding-top: 5%; height: 100%; width: 50%;">
        <v-btn @click="felixBagAuxStore.hideInteractive('menu-suporte'); audio.pause(); felixBagAuxStore.unmuteVideo()"
          variant="text" color="inherit"><img
            src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/642712b9-7c61-4e25-87b0-5b7aefc49d67.svg"
            alt=""></v-btn>
        <p class="submenu-title">Suporte</p>
      </div>

      <div style="height: 100%; display: flex; align-items: center; justify-content: center;">
        <img
          src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/7fbd644f-e974-49f6-b780-27ebd106cbe9.svg"
          alt="">
      </div>
    </v-row>

    <div class="suporte-buttons">
      <button @click="openSubmenu = 'perguntas_frequentes'">
        <div>
          <div
            style="width: 50px; height: 50px; border-radius: 50%; background: #F6E7FF; display: flex; align-items: center; justify-content: center;">
            <img
              src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/10d4affa-0770-43f1-8fa5-7561f064e83d.svg"
              alt="">
          </div>
          <p>Perguntas mais frequentes</p>
        </div>
      </button>

      <button @click="openSubmenu = 'reportar_duvida'">
        <div>
          <div
            style="width: 50px; height: 50px; border-radius: 50%; background: #F6E7FF; display: flex; align-items: center; justify-content: center;">

            <img
              src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/34eb3814-4621-4cf0-83f2-9e3aebdf9b32.svg"
              alt="">
          </div>
          <p>Reportar dúvida ou problema</p>
        </div>
      </button>
    </div>
  </div>

  <PerguntasFrequentes @close-submenu="openSubmenu = ''" v-if="openSubmenu === 'perguntas_frequentes'" />
  <ReportarDuvida @close-submenu="openSubmenu = ''" v-if="openSubmenu === 'reportar_duvida'" />
</template>

<style scoped>
#menu-suporte {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 3;
  background-color: white;
}

.header {
  height: 25%;
  background-color: #BC4AFF;
}

.submenu-title {
  color: white;
  font-size: 20px;
  text-align: start;
  margin-left: 7.5%;
  margin-top: 10%;
}

.suporte-buttons {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin-top: 10%;
}

.suporte-buttons button {
  border: none;
  background-color: inherit;
  cursor: pointer;
  width: 45%;
  height: 140px;
}

.suporte-buttons button>div {
  width: 100%;
  height: 100%;
  background-color: #F9F9F9;
  border: 1px solid #E8E8E8;
  border-radius: 8PX;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
}
</style>